import GeoJSON from "ol/format/GeoJSON";
import centroid from "@turf/centroid";
import { asArray, asString } from "ol/color";

const getFeatureCentroid = feature => {
  const featureGeometry = new GeoJSON().writeGeometryObject(
    feature.getGeometry()
  );
  return centroid(featureGeometry);
};

function colorToRgba(color, opacity) {
  const [r, g, b] = Array.from(asArray(color));
  return asString([r, g, b, 1 - opacity]);
}

function getWMSLayers() {
  return Promise.all([
    this.$store.dispatch('getLayersGroups'),
    this.$store.dispatch("getLayers").then(r => {
      if (r.status === 200 && r.data.layers.length > 0) {
        const layers = r.data.layers
          .filter(layer => layer.wms_layers)
          .map(layer => {
            layer.wms_layers = layer.wms_layers.split(",");
            return layer;
          });
        const userLayers = r.data.layers.filter(
          layer => layer.layer_type === "user"
        );
        for (const layer of userLayers) {
          if (layer.style.type === 'unique') {
            const uniques = {};
            for (const unique in layer.style.uniques) {
              const uniqueValue = layer.style.uniques[unique];
              uniqueValue.fillColor = colorToRgba(
                uniqueValue.fillColor,
                uniqueValue.opacity / 100
              );
              uniqueValue.strokeColor = colorToRgba(
                uniqueValue.strokeColor,
                uniqueValue.opacity / 100
              );
              uniques[unique] = uniqueValue;
            }
            layer.style.uniques = uniques;
          } else {
            layer.style.fillColor = colorToRgba(
              layer.style.fillColor,
              layer.style.opacity / 100
            );
            layer.style.strokeColor = colorToRgba(
              layer.style.strokeColor,
              layer.style.opacity / 100
            );
          }
        }
        const systemLayers = r.data.layers.filter(
          layer => layer.layer_type === "system"
        );
        for (const layer of systemLayers) {
          if (layer.style.type === 'unique') {
            const uniques = {};
            for (const unique in layer.style.uniques) {
              const uniqueValue = layer.style.uniques[unique];
              uniqueValue.fillColor = colorToRgba(
                uniqueValue.fillColor,
                uniqueValue.opacity / 100
              );
              uniqueValue.strokeColor = colorToRgba(
                uniqueValue.strokeColor,
                uniqueValue.opacity / 100
              );
              uniques[unique] = uniqueValue;
            }
            layer.style.uniques = uniques;
            const attributeType = layer.fields.find(field => field.name === layer.style.attribute).type;
            if (attributeType === 'multiselect'){
              layer.style.isArrayValue = true;
            }
          } else {
            layer.style.fillColor = colorToRgba(
              layer.style.fillColor,
              layer.style.opacity / 100
            );
            layer.style.strokeColor = colorToRgba(
              layer.style.strokeColor,
              layer.style.opacity / 100
            );
          }
          if (layer.name_pl === "Oferty inwestycyjne") {
            this.$store.commit("setOffersStyle", layer.style);
          } else {
            this.$store.commit("setParcelsStyle", layer.style);
          }
        }
        this.$store.commit("setWmsList", layers);
        this.$store.commit("setUserList", userLayers);
        this.$store.commit("setSystemList", systemLayers);
      }
    })
  ]);
}

export { getFeatureCentroid, getWMSLayers };
